import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'tiptap-vuetify/dist/main.css'
import tailwind from '../../tailwind.config'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: tailwind.theme.colors.primary.default,
        accent: tailwind.theme.colors.primary.default,
      },
    },
  },
})

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'mdi',
})

export default vuetify
